export const isUnsavedPricelistOffering = (product: unknown): boolean => {
    const offering = product as { isNew?: boolean; IsNew?: boolean } | null | undefined;
    return offering?.isNew === true || offering?.IsNew === true;
};